/**
 * 判断接口是否调用成功
 * @param {接口返回值}} code
 * @returns
 */
export const isSuccess = (code) => {
  return code == 1
}
/**
 * 判断是否为空
 * @param {*} data
 */
export const isEmpty = (data) => {
  if (data instanceof Array) {
    if (data.length == 0) {
      return true
    } else {
      return data.some((item) => isEmpty(item))
    }
  } else if (data instanceof Object) {
    let values = Object.values(data)
    if (values.length == 0) {
      return true
    } else {
      return values.some((item) => isEmpty(item))
    }
  } else if (typeof data === 'string' && data.trim(' ') === '') {
    return true
  } else if (data === null || data == undefined) {
    return true
  } else {
    return false
  }
}

/**
 * 拼写完整的路径
 * @param {*} url
 * @returns
 */
export const getCompletionUrl = (url) => {
  if (isEmpty(url)) {
    return ''
  }
  return process.env.VUE_APP_PIC_URL + url
}
